module.exports = __webpack_public_path__ + "media/images/edit-08a45d5e0556aeab0d134bec170ee63a.svg";